import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import AssetCycleRunForm from '../AssetCycleRunForm';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById } from '../../utils/DataAccessUtils';
import { FC, useEffect, useMemo } from 'react';
import {
	cycleEventsRestCrudThunksForBuyer,
	cycleEventsRestCrudThunksForSupplier,
} from '../../thunks/cycle_events_thunks';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

const queryString = require('qs');

interface AssetCycleRunEditPageProps {
	match: any;
	history: any;
	cycleRun: any;
	fetching: boolean;
	getCycleEvent: (runId: number) => any;
	userType: string;
}

const AssetCycleRunEditPage: FC<AssetCycleRunEditPageProps> = ({
	match,
	history,
	cycleRun,
	fetching,
	getCycleEvent,
	userType,
}): React.ReactElement => {
	const cycleRunId = useMemo(() => match.params.id, [match.params.id]);

	useEffect(() => {
		getCycleEvent(cycleRunId);
	}, [cycleRunId]);

	return fetching ? (
		<PageLoadingPlaceholder />
	) : (
		<EditPage
			title="Edit Asset Cycle Run"
			formComponentProps={{
				formData: cycleRun,
				isEditForm: true,
				onSuccess: (rec) => history.push(`/${userType}/assetcycleevents/detail/${rec.id}/details`),
			}}
			fetching={fetching}
			FormComponent={AssetCycleRunForm}
		/>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_events),
	fetching: state.cycle_events.fetching,
	match: ownProps.match,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getCycleEvent: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? cycleEventsRestCrudThunksForSupplier.readOne(id)
				: cycleEventsRestCrudThunksForBuyer.readOne(id)
		),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(AssetCycleRunEditPage))
);
